<template>
  <div class="isd d-inline-block">
    <svg
      aria-hidden="true"
      focusable="false"
      class="isd-sprite"
    >
      <defs>
        <symbol
          :id="iconIds.bookOpen"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 7v14" />
          <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
        </symbol>
        <symbol
          :id="iconIds.listOrdered"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M10 12h11" />
          <path d="M10 18h11" />
          <path d="M10 6h11" />
          <path d="M4 10h2" />
          <path d="M4 6h1v4" />
          <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" />
        </symbol>
        <symbol
          :id="iconIds.chevronDown"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m6 9 6 6 6-6" />
        </symbol>
        <symbol
          :id="iconIds.chevronUp"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m18 15-6-6-6 6" />
        </symbol>
        <symbol
          :id="iconIds.chevronRight"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m9 18 6-6-6-6" />
        </symbol>
        <symbol
          :id="iconIds.wand"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72" />
          <path d="m14 7 3 3" />
          <path d="M5 6v4" />
          <path d="M19 14v4" />
          <path d="M10 2v2" />
          <path d="M7 8H3" />
          <path d="M21 16h-4" />
          <path d="M11 3H9" />
        </symbol>
        <symbol
          :id="iconIds.chartColumn"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M3 3v16a2 2 0 0 0 2 2h16" />
          <path d="M18 17V9" />
          <path d="M13 17V5" />
          <path d="M8 17v-3" />
        </symbol>
        <symbol
          :id="iconIds.sparkles"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
          <path d="M20 3v4" />
          <path d="M22 5h-4" />
          <path d="M4 17v2" />
          <path d="M5 18H3" />
        </symbol>
        <symbol
          :id="iconIds.check"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M20 6 9 17l-5-5" />
        </symbol>
        <symbol
          :id="iconIds.pencilLine"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 20h9" />
          <path d="M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z" />
          <path d="m15 5 3 3" />
        </symbol>
        <symbol
          :id="iconIds.bookmarkPlus"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" />
          <line
            x1="12"
            x2="12"
            y1="7"
            y2="13"
          />
          <line
            x1="15"
            x2="9"
            y1="10"
            y2="10"
          />
        </symbol>
        <symbol
          :id="iconIds.settings"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
          <circle
            cx="12"
            cy="12"
            r="3"
          />
        </symbol>
        <symbol
          :id="iconIds.trash2"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M3 6h18" />
          <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
          <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
          <line
            x1="10"
            x2="10"
            y1="11"
            y2="17"
          />
          <line
            x1="14"
            x2="14"
            y1="11"
            y2="17"
          />
        </symbol>
        <symbol
          :id="iconIds.x"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </symbol>
        <symbol
          :id="iconIds.search"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle
            cx="11"
            cy="11"
            r="8"
          />
          <path d="m21 21-4.3-4.3" />
        </symbol>
        <symbol
          :id="iconIds.plus"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M5 12h14" />
          <path d="M12 5v14" />
        </symbol>
        <symbol
          :id="iconIds.pencil"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
          <path d="m15 5 4 4" />
        </symbol>
        <symbol
          :id="iconIds.arrowLeft"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m12 19-7-7 7-7" />
          <path d="M19 12H5" />
        </symbol>
        <symbol
          :id="iconIds.save"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
          <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" />
          <path d="M7 3v4a1 1 0 0 0 1 1h7" />
        </symbol>
      </defs>
    </svg>
    <div class="dropdown">
      <button
        :id="triggerId"
        ref="triggerBtn"
        class="btn isd__btn"
        :class="{ 'isd__btn--open': isOpen }"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        :aria-expanded="isOpen ? 'true' : 'false'"
        title="Choose the sequence driving this report"
        @click="handleToggle"
      >
        <span
          class="isd__btnIcon"
          aria-hidden="true"
        >
          <svg
            class="isd-svg isd-svg--16"
            aria-hidden="true"
          >
            <use
              :href="`#${iconIds.listOrdered}`"
              :xlink:href="`#${iconIds.listOrdered}`"
            />
          </svg>
        </span>
        <span class="isd__btnLabel text-truncate">
          {{ activeLabel }}
        </span>
        <span
          class="isd__btnChevron"
          aria-hidden="true"
        >
          <svg
            class="isd-svg isd-svg--12"
            aria-hidden="true"
          >
            <use
              :href="`#${iconIds.chevronDown}`"
              :xlink:href="`#${iconIds.chevronDown}`"
            />
          </svg>
        </span>
      </button>

      <div
        class="dropdown-menu dropdown-menu-right isd__menu"
        :aria-labelledby="triggerId"
        @click.stop
      >
        <div class="isd__sectionTitle">
          <span
            class="isd__sectionIcon"
            aria-hidden="true"
          >
            <svg
              class="isd-svg isd-svg--14"
              aria-hidden="true"
            >
              <use
                :href="`#${iconIds.wand}`"
                :xlink:href="`#${iconIds.wand}`"
              />
            </svg>
          </span>
          Auto sources
        </div>

        <button
          v-for="src in autoSources"
          :key="src.id"
          class="dropdown-item isd__item"
          type="button"
          @click="selectSource(src)"
        >
          <span
            class="isd__itemIcon"
            aria-hidden="true"
          >
            <svg
              class="isd-svg isd-svg--14"
              aria-hidden="true"
            >
              <use
                :href="`#${iconIds[src.iconKey]}`"
                :xlink:href="`#${iconIds[src.iconKey]}`"
              />
            </svg>
          </span>
          <span class="isd__itemBody">
            <span class="isd__itemTitle text-truncate">{{ src.title }}</span>
            <span class="isd__itemSub text-truncate">{{ src.subtitle }}</span>
          </span>
          <span
            v-if="activeType === 'auto' && activeId === src.id"
            class="isd__check"
            aria-hidden="true"
          >
            <svg
              class="isd-svg isd-svg--14 isd-svg--check"
              aria-hidden="true"
            >
              <use
                :href="`#${iconIds.check}`"
                :xlink:href="`#${iconIds.check}`"
              />
            </svg>
          </span>
        </button>

        <div class="dropdown-divider" />

        <div class="isd__sectionTitle">
          <span
            class="isd__sectionIcon"
            aria-hidden="true"
          >
            <svg
              class="isd-svg isd-svg--14"
              aria-hidden="true"
            >
              <use
                :href="`#${iconIds.bookOpen}`"
                :xlink:href="`#${iconIds.bookOpen}`"
              />
            </svg>
          </span>
          Playbooks
          <span class="isd__sectionMeta">visual sequences</span>
        </div>

        <div class="isd__searchWrap">
          <span
            class="isd__searchIcon"
            aria-hidden="true"
          >
            <svg
              class="isd-svg isd-svg--12"
              aria-hidden="true"
            >
              <use
                :href="`#${iconIds.search}`"
                :xlink:href="`#${iconIds.search}`"
              />
            </svg>
          </span>
          <input
            v-model="playbookSearch"
            class="form-control isd__searchInput"
            placeholder="Search playbooks…"
          >
        </div>

        <div class="isd__playbookScroll">
          <button
            v-for="pb in filteredPlaybooks"
            :key="pb.id"
            class="dropdown-item isd__item"
            type="button"
            @click="selectPlaybook(pb)"
          >
            <span
              class="isd__itemIcon"
              aria-hidden="true"
            >
              <svg
                class="isd-svg isd-svg--14"
                aria-hidden="true"
              >
                <use
                  :href="`#${iconIds.bookOpen}`"
                  :xlink:href="`#${iconIds.bookOpen}`"
                />
              </svg>
            </span>
            <span class="isd__itemBody">
              <span class="isd__itemTitle text-truncate">{{ pb.title }}</span>
              <span class="isd__itemSub text-truncate">{{ pb.subtitle }}</span>
            </span>
            <span
              v-if="activeType === 'playbook' && activeId === pb.id"
              class="isd__check"
              aria-hidden="true"
            >
              <svg
                class="isd-svg isd-svg--14 isd-svg--check"
                aria-hidden="true"
              >
                <use
                  :href="`#${iconIds.check}`"
                  :xlink:href="`#${iconIds.check}`"
                />
              </svg>
            </span>
          </button>
        </div>

        <div class="dropdown-divider" />

        <div
          class="isd__submenu"
          @mouseenter="seqOptionsOpen = true"
          @mouseleave="seqOptionsOpen = false"
        >
          <button
            class="dropdown-item isd__item isd__submenuTrigger"
            type="button"
          >
            <span
              class="isd__itemIcon"
              aria-hidden="true"
            >
              <svg
                class="isd-svg isd-svg--14"
                aria-hidden="true"
              >
                <use
                  :href="`#${iconIds.settings}`"
                  :xlink:href="`#${iconIds.settings}`"
                />
              </svg>
            </span>
            <span class="isd__actionText">Sequence Options</span>
            <span
              class="isd__submenuChevron"
              aria-hidden="true"
            >
              <svg
                class="isd-svg isd-svg--16"
                aria-hidden="true"
              >
                <use
                  :href="`#${iconIds.chevronRight}`"
                  :xlink:href="`#${iconIds.chevronRight}`"
                />
              </svg>
            </span>
          </button>

          <div
            v-show="seqOptionsOpen"
            class="isd__submenuContent"
            role="menu"
            aria-label="Sequence options"
          >
            <button
              class="dropdown-item isd__item isd__action"
              type="button"
              @click="openBuildModal"
            >
              <span
                class="isd__itemIcon"
                aria-hidden="true"
              >
                <svg
                  class="isd-svg isd-svg--14"
                  aria-hidden="true"
                >
                  <use
                    :href="`#${iconIds.pencilLine}`"
                    :xlink:href="`#${iconIds.pencilLine}`"
                  />
                </svg>
              </span>
              <span class="isd__actionText">Build a Custom Sequence…</span>
            </button>

            <button
              class="dropdown-item isd__item isd__action"
              type="button"
              @click="openSaveModal"
            >
              <span
                class="isd__itemIcon"
                aria-hidden="true"
              >
                <svg
                  class="isd-svg isd-svg--14"
                  aria-hidden="true"
                >
                  <use
                    :href="`#${iconIds.bookmarkPlus}`"
                    :xlink:href="`#${iconIds.bookmarkPlus}`"
                  />
                </svg>
              </span>
              <span class="isd__actionText">Save Current as New Sequence…</span>
            </button>

            <button
              class="dropdown-item isd__item isd__action"
              type="button"
              @click="openLibraryModal"
            >
              <span
                class="isd__itemIcon"
                aria-hidden="true"
              >
                <svg
                  class="isd-svg isd-svg--14"
                  aria-hidden="true"
                >
                  <use
                    :href="`#${iconIds.settings}`"
                    :xlink:href="`#${iconIds.settings}`"
                  />
                </svg>
              </span>
              <span class="isd__actionText">Manage Sequence Library…</span>
            </button>
          </div>
        </div>

        <div class="dropdown-divider" />

        <div class="isd__sectionTitle">
          <span
            class="isd__sectionIcon"
            aria-hidden="true"
          >
            <svg
              class="isd-svg isd-svg--16"
              aria-hidden="true"
            >
              <use
                :href="`#${iconIds.listOrdered}`"
                :xlink:href="`#${iconIds.listOrdered}`"
              />
            </svg>
          </span>
          My Sequences
          <span class="isd__sectionMeta">slot order</span>
        </div>

        <div class="isd__seqScroll">
          <button
            v-for="seq in sequences"
            :key="seq.id"
            class="dropdown-item isd__item"
            type="button"
            @click="selectSequence(seq)"
          >
            <span
              class="isd__itemIcon"
              aria-hidden="true"
            >
              <svg
                class="isd-svg isd-svg--16"
                aria-hidden="true"
              >
                <use
                  :href="`#${iconIds.listOrdered}`"
                  :xlink:href="`#${iconIds.listOrdered}`"
                />
              </svg>
            </span>
            <span class="isd__itemBody">
              <span class="isd__itemTitle text-truncate">{{ seq.name }}</span>
              <span class="isd__itemSub text-truncate">{{ seq.category }} · {{ seq.slots.length }} slots</span>
            </span>
            <span
              v-if="activeType === 'sequence' && activeId === seq.id"
              class="isd__check"
              aria-hidden="true"
            >
              <svg
                class="isd-svg isd-svg--14 isd-svg--check"
                aria-hidden="true"
              >
                <use
                  :href="`#${iconIds.check}`"
                  :xlink:href="`#${iconIds.check}`"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- Save sequence modal -->
    <div
      :id="saveModalId"
      class="modal fade isd-modal isd-modal--save"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered isd-modal__dialog isd-modal__dialog--md"
        role="document"
      >
        <div class="modal-content isd-modal__content">
          <div class="isd-modal__header">
            <div class="isd-modal__titleRow">
              <span
                class="isd-modal__titleIcon"
                aria-hidden="true"
              >
                <svg
                  class="isd-svg isd-svg--20"
                  aria-hidden="true"
                >
                  <use
                    :href="`#${iconIds.bookmarkPlus}`"
                    :xlink:href="`#${iconIds.bookmarkPlus}`"
                  />
                </svg>
              </span>
              <h5 class="isd-modal__title mb-0">
                Save Sequence to Library
              </h5>
            </div>
          </div>

          <div class="isd-modal__body">
            <div class="isd-save__field">
              <label
                class="isd-label isd-label--save"
                :for="saveNameId"
              >Name</label>
              <input
                :id="saveNameId"
                v-model="saveName"
                class="form-control isd-input isd-input--h10 isd-input--rounded"
                placeholder="e.g. MC Frozen Standard"
              >
            </div>
            <div class="isd-caption">
              {{ buildSlots.length }} slots will be saved.
            </div>
          </div>

          <div class="isd-modal__footer isd-modal__footer--right">
            <button
              type="button"
              class="btn isd-btn isd-btn--ghost"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn isd-btn isd-btn--primary"
              @click="saveToLibrary"
            >
              Save
            </button>
          </div>

          <button
            type="button"
            class="isd-modal__close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <svg
                class="isd-svg isd-svg--16"
                aria-hidden="true"
              >
                <use
                  :href="`#${iconIds.x}`"
                  :xlink:href="`#${iconIds.x}`"
                />
              </svg>
            </span>
            <span class="sr-only">Close</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Sequence library modal -->
    <div
      :id="libraryModalId"
      class="modal fade isd-modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered isd-modal__dialog isd-modal__dialog--lg"
        role="document"
      >
        <div class="modal-content isd-modal__content">
          <div class="isd-modal__header">
            <div class="isd-modal__titleRow">
              <span
                class="isd-modal__titleIcon"
                aria-hidden="true"
              >
                <svg
                  class="isd-svg isd-svg--20"
                  aria-hidden="true"
                >
                  <use
                    :href="`#${iconIds.listOrdered}`"
                    :xlink:href="`#${iconIds.listOrdered}`"
                  />
                </svg>
              </span>
              <h5 class="isd-modal__title mb-0">
                Sequence Library
              </h5>
            </div>
            <div class="isd-modal__subtitle">
              Reusable image sequences you can apply to any PDP. Like Audiences — but for slot order.
            </div>
          </div>

          <div class="isd-modal__body">
            <div class="isd-libraryTop">
              <div class="isd-search">
                <span
                  class="isd-search__icon"
                  aria-hidden="true"
                >
                  <svg
                    class="isd-svg isd-svg--14"
                    aria-hidden="true"
                  >
                    <use
                      :href="`#${iconIds.search}`"
                      :xlink:href="`#${iconIds.search}`"
                    />
                  </svg>
                </span>
                <input
                  v-model="search"
                  class="form-control isd-input isd-search__input"
                  placeholder="Search sequences..."
                >
              </div>
              <button
                type="button"
                class="btn isd-btn isd-btn--primary"
                @click="openNewSequenceModal"
              >
                <span
                  class="isd-btn__icon"
                  aria-hidden="true"
                >
                  <svg
                    class="isd-svg isd-svg--14"
                    aria-hidden="true"
                  >
                    <use
                      :href="`#${iconIds.plus}`"
                      :xlink:href="`#${iconIds.plus}`"
                    />
                  </svg>
                </span>
                New Sequence
              </button>
            </div>

            <div class="isd-libraryList">
              <ul class="list-unstyled mb-0">
                <li
                  v-for="seq in filteredSequences"
                  :key="`lib-${seq.id}`"
                  class="isd-row"
                >
                  <div class="isd-row__main">
                    <div class="isd-row__titleRow">
                      <div class="isd-row__title text-truncate">
                        {{ seq.name }}
                      </div>
                      <div class="isd-pill">
                        {{ seq.scope }}
                      </div>
                    </div>
                    <div class="seq-slots">
                      <span
                        v-for="(slot, index) in seq.slots"
                        :key="slot.id"
                      >
                        {{ slot.label }}<span v-if="index < seq.slots.length - 1"> · </span>
                      </span>
                    </div>
                  </div>

                  <div class="isd-row__actions">
                    <button
                      type="button"
                      class="btn isd-btn isd-btn--primary isd-btn--h8"
                      @click="selectSequence(seq); closeAll()"
                    >
                      Apply
                    </button>
                    <button
                      type="button"
                      class="btn isd-iconBtn"
                      :title="`Edit ${seq.name}`"
                      @click="editSequence(seq)"
                    >
                      <span
                        aria-hidden="true"
                      >
                        <svg
                          class="isd-svg isd-svg--14"
                          aria-hidden="true"
                        >
                          <use
                            :href="`#${iconIds.pencil}`"
                            :xlink:href="`#${iconIds.pencil}`"
                          />
                        </svg>
                      </span>
                    </button>
                    <button
                      type="button"
                      class="btn isd-iconBtn isd-iconBtn--danger"
                      :title="`Delete ${seq.name}`"
                      @click="handleDelete(seq.id)"
                    >
                      <span
                        aria-hidden="true"
                      >
                        <svg
                          class="isd-svg isd-svg--14"
                          aria-hidden="true"
                        >
                          <use
                            :href="`#${iconIds.trash2}`"
                            :xlink:href="`#${iconIds.trash2}`"
                          />
                        </svg>
                      </span>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <button
            type="button"
            class="isd-modal__close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <svg
                class="isd-svg isd-svg--16"
                aria-hidden="true"
              >
                <use
                  :href="`#${iconIds.x}`"
                  :xlink:href="`#${iconIds.x}`"
                />
              </svg>
            </span>
            <span class="sr-only">Close</span>
          </button>
        </div>
      </div>
    </div>

    <!-- New sequence modal -->
    <div
      :id="newModalId"
      class="modal fade isd-modal isd-modal--new"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered isd-modal__dialog isd-modal__dialog--lg"
        role="document"
      >
        <div class="modal-content isd-modal__content">
          <div class="isd-modal__header">
            <div class="isd-modal__titleRow">
              <span
                class="isd-modal__titleIcon"
                aria-hidden="true"
              >
                <svg
                  class="isd-svg isd-svg--20"
                  aria-hidden="true"
                >
                  <use
                    :href="`#${iconIds.listOrdered}`"
                    :xlink:href="`#${iconIds.listOrdered}`"
                  />
                </svg>
              </span>
              <h5 class="isd-modal__title mb-0">
                New Sequence
              </h5>
            </div>
            <div class="isd-modal__subtitle">
              An ordered list of slot labels (e.g. Mobile Hero, Lifestyle, How To).
            </div>
          </div>

          <div class="isd-modal__body">
            <div class="isd-new__grid">
              <div class="isd-new__field">
                <label
                  class="isd-label isd-label--new"
                  :for="newNameId"
                >Name</label>
                <input
                  :id="newNameId"
                  v-model="newSeqName"
                  class="form-control isd-input isd-input--h10 isd-input--rounded"
                  placeholder="e.g. MC Frozen Standard"
                >
              </div>
              <div class="isd-new__field">
                <label
                  class="isd-label isd-label--new"
                  :for="newScopeId"
                >Scope</label>
                <input
                  :id="newScopeId"
                  v-model="newSeqScope"
                  class="form-control isd-input isd-input--h10 isd-input--rounded"
                  placeholder="Global or a category name"
                >
              </div>
            </div>

            <div class="isd-new__slots">
              <label class="isd-label isd-label--new">Slots (in order)</label>
              <div class="isd-new__slotBox">
                <div
                  v-if="!newSeqSlots.length"
                  class="isd-new__empty"
                >
                  No slots yet. Add one below.
                </div>
                <div
                  v-else
                  class="isd-new__slotList"
                >
                  <div
                    v-for="(s, idx) in newSeqSlots"
                    :key="`new-slot-${idx}`"
                    class="isd-new__slotRow"
                  >
                    <div class="isd-new__slotNum">
                      {{ String(idx + 1).padStart(2, "0") }}
                    </div>
                    <div class="isd-new__slotText text-truncate">
                      {{ s.label }}
                    </div>
                  </div>
                </div>

                <div class="isd-new__slotAdd">
                  <input
                    v-model="newSeqSlotText"
                    class="form-control isd-input isd-input--rounded isd-new__slotInput"
                    placeholder="Add slot label (e.g. Mobile Hero, Lifestyle, How To)"
                    @keydown.enter.prevent="addNewSeqSlot"
                  >
                  <button
                    class="btn isd-btn isd-btn--primary isd-new__addBtn"
                    type="button"
                    @click="addNewSeqSlot"
                  >
                    <span
                      class="isd-btn__icon"
                      aria-hidden="true"
                    >
                      <svg
                        class="isd-svg isd-svg--14"
                        aria-hidden="true"
                      >
                        <use
                          :href="`#${iconIds.plus}`"
                          :xlink:href="`#${iconIds.plus}`"
                        />
                      </svg>
                    </span>
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="isd-modal__footer">
            <button
              type="button"
              class="btn isd-btn isd-btn--ghost"
              @click="backToLibraryFromNew"
            >
              <span
                class="isd-btn__icon"
                aria-hidden="true"
              >
                <svg
                  class="isd-svg isd-svg--14"
                  aria-hidden="true"
                >
                  <use
                    :href="`#${iconIds.arrowLeft}`"
                    :xlink:href="`#${iconIds.arrowLeft}`"
                  />
                </svg>
              </span>
              Back to library
            </button>
            <button
              :disabled="!newSeqName || newSeqSlots.length === 0"
              type="button"
              class="btn isd-btn isd-btn--primary"
              @click="saveNewSequence"
            >
              <span
                class="isd-btn__icon"
                aria-hidden="true"
              >
                <svg
                  class="isd-svg isd-svg--14"
                  aria-hidden="true"
                >
                  <use
                    :href="`#${iconIds.save}`"
                    :xlink:href="`#${iconIds.save}`"
                  />
                </svg>
              </span>
              Save Sequence
            </button>
          </div>

          <button
            type="button"
            class="isd-modal__close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <svg
                class="isd-svg isd-svg--16"
                aria-hidden="true"
              >
                <use
                  :href="`#${iconIds.x}`"
                  :xlink:href="`#${iconIds.x}`"
                />
              </svg>
            </span>
            <span class="sr-only">Close</span>
          </button>
        </div>
      </div>
    </div>

    <BuildSequenceModal
      :sequence="selectedSequence"
      @save="handleSave"
      @update="handleUpdate"
    />
  </div>
</template>

<script>
import BuildSequenceModal from '@frontend/components/common/dashboard/modals/BuildSequenceModal.vue';

const STORAGE_KEY = "image_sequence_library_v1";
const ACTIVE_KEY = "image_sequence_active_v1";

function uid(prefix, n) {
  return `${prefix}-${n}`;
}

function normalizeLines(text) {
  return String(text || "")
    .split(/\r?\n/)
    .map(s => s.trim())
    .filter(Boolean);
}

export default {
  name: "ImageSequenceDropdown",
  components: {
    BuildSequenceModal,
  },
  props: {
    visualBenchmarkSubtitle: {
      type: String,
      default: "From the latest VB for Frozen Family Meals",
    },
    defaultVisualBenchmarkLabel: {
      type: String,
      default: "Sequence: Visual Benchmark — Frozen Family Meals",
    },
    playbooks: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      isOpen: false,
      activeType: "auto",
      activeId: "visual-benchmark",
      sequences: [],
      search: "",
      playbookSearch: "",
      playbooksRemote: [],
      playbooksLoading: false,
      seqOptionsOpen: false,
      buildTab: "list",
      buildText: "Hero / Pack Shot\nIngredient Callout\nLifestyle (Plated)\nIngredient Hero\nLifestyle (Plated)\nPrep / Microwave Steps\nNutrition / Claims Panel",
      newSlot: "",
      saveName: "Visual Benchmark — Frozen Family Meals",
      editingSequenceId: null,
      newSeqName: "",
      newSeqScope: "Global",
      newSeqSlots: [],
      newSeqSlotText: "",
      editSeqName: "",
      editSeqScope: "Global",
      editSeqSlots: [],
      editSeqSlotText: "",
      autoSources: [
        {
          id: "visual-benchmark",
          title: "Visual Benchmark",
          subtitle: "From the latest VB for Frozen Family Meals",
          iconKey: "chartColumn",
        },
        {
          id: "best-practices",
          title: "Best Practices (AI)",
          subtitle: "AI-suggested sequence for this category",
          iconKey: "sparkles",
        },
      ],
      selectedSequence: null,
      nextId: 0,
    };
  },
  computed: {
    triggerId() {
      return uid("isd-trigger", this._uid);
    },
    buildModalId() {
      return uid("isd-build", this._uid);
    },
    saveModalId() {
      return uid("isd-save", this._uid);
    },
    libraryModalId() {
      return uid("isd-library", this._uid);
    },
    newModalId() {
      return uid("isd-new", this._uid);
    },
    editModalId() {
      return uid("isd-edit", this._uid);
    },
    saveNameId() {
      return uid("isd-save-name", this._uid);
    },
    newNameId() {
      return uid("isd-new-name", this._uid);
    },
    newScopeId() {
      return uid("isd-new-scope", this._uid);
    },
    editNameId() {
      return uid("isd-edit-name", this._uid);
    },
    editScopeId() {
      return uid("isd-edit-scope", this._uid);
    },
    activeLabel() {
      if (this.activeType === "auto") {
        if (this.activeId === "visual-benchmark") return this.defaultVisualBenchmarkLabel;
        return "Sequence: Best Practices (AI)";
      }
      if (this.activeType === "playbook") {
        const pb = (this.playbooks || []).find(p => p && p.id === this.activeId);
        return `Sequence: ${pb ? pb.title : "Playbook"}`;
      }
      const seq = this.sequences.find(s => s.id === this.activeId);
      return `Sequence: ${seq ? seq.name : "AI-recommended"}`;
    },
    buildSlots() {
      return normalizeLines(this.buildText);
    },
    iconIds() {
      const p = uid("isd-icon", this._uid);
      return {
        bookOpen: `${p}-bookOpen`,
        listOrdered: `${p}-listOrdered`,
        chevronDown: `${p}-chevronDown`,
        chevronUp: `${p}-chevronUp`,
        chevronRight: `${p}-chevronRight`,
        wand: `${p}-wand`,
        chartColumn: `${p}-chartColumn`,
        sparkles: `${p}-sparkles`,
        check: `${p}-check`,
        pencilLine: `${p}-pencilLine`,
        bookmarkPlus: `${p}-bookmarkPlus`,
        settings: `${p}-settings`,
        trash2: `${p}-trash2`,
        x: `${p}-x`,
        search: `${p}-search`,
        plus: `${p}-plus`,
        pencil: `${p}-pencil`,
        arrowLeft: `${p}-arrowLeft`,
        save: `${p}-save`,
      };
    },
    canSaveBuiltToLibrary() {
      return Boolean(String(this.saveName || "").trim()) && this.buildSlots.length > 0;
    },
    canSaveEditSequence() {
      return Boolean(String(this.editSeqName || "").trim()) && this.editSeqSlots.length > 0;
    },
    filteredSequences() {
      const q = String(this.search || "").trim().toLowerCase();
      if (!q) return this.sequences;

      return this.sequences.filter(s => {
        const hay = `
          ${s.name || ""}
          ${s.scope || ""}
          ${(s.slots || []).map(slot => slot.label).join(" ")}
        `.toLowerCase();

        return hay.includes(q);
      });
    },
    filteredPlaybooks() {
      const list = (Array.isArray(this.playbooksRemote) && this.playbooksRemote.length)
        ? this.playbooksRemote
        : (Array.isArray(this.playbooks) ? this.playbooks : []);
      const q = String(this.playbookSearch || "").trim().toLowerCase();
      const filtered = !q
        ? list
        : list.filter(p => {
          const hay = `${p.title || ""} ${p.subtitle || ""}`.toLowerCase();
          return hay.includes(q);
        });
      return filtered;
    },
  },
  created() {
    this.loadLibrary();
    this.loadActive();
    this.fetchPlaybooks();
    document.addEventListener("click", this.onDocClick, true);
  },
  async mounted() {
    await this.fetchSequences();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onDocClick, true);
  },
  methods: {
    handleToggle() {
      this.isOpen = !this.isOpen;
      if (!this.isOpen) this.blurTrigger();
      if (this.isOpen) this.fetchPlaybooks();
    },
    async fetchPlaybooks() {
      if (this.playbooksLoading) return;
      const axios = window.axios;
      if (!axios || typeof axios.get !== "function") return;

      this.playbooksLoading = true;
      try {
        const resp = await axios.get("/analytics-history/playbook-reports", { params: { format: "list" } });
        const list = resp && resp.data && Array.isArray(resp.data.playbooks) ? resp.data.playbooks : [];
        this.playbooksRemote = list.map(p => ({
          id: String(p.id),
          title: String(p.title || ""),
          subtitle: String(p.subtitle || ""),
          report_link: String(p.report_link || ""),
          report_uuid: p.report_uuid ? String(p.report_uuid) : "",
        })).filter(p => Boolean(p.id) && Boolean(p.title));
      } catch (e) {
        // fail silently; fallback to prop playbooks if provided
      } finally {
        this.playbooksLoading = false;
      }
    },
    blurTrigger() {
      const el = this.$refs.triggerBtn;
      if (el && typeof el.blur === "function") el.blur();
    },
    onDocClick(e) {
      const root = this.$el;
      if (!root) return;
      if (!root.contains(e.target)) {
        this.isOpen = false;
        this.blurTrigger();
      }
    },
    closeAll() {
      this.isOpen = false;
      this.seqOptionsOpen = false;
      this.closeDropdown();
      this.blurTrigger();
    },
    closeDropdown() {
      this.isOpen = false;
    },
    loadLibrary() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const list = raw ? JSON.parse(raw) : null;
        if (Array.isArray(list) && list.length) {
          this.sequences = list;
          return;
        }
      } catch (e) {
        return;
      }

      this.sequences = [
        {
          id: "health-wellness",
          name: "Health & Wellness",
          category: "Health & Wellness",
          slots: ["Mobile Hero", "Key Benefits", "Ingredients / What's Inside", "How To Use", "Clinical / Reason to Believe", "Reviews & Awards"],
        },
        {
          id: "tents",
          name: "Tents",
          category: "Tents",
          slots: ["Mobile Hero", "Setup / In-Use", "Capacity & Dimensions", "Weather Protection", "Materials & Durability", "What's Included", "Reviews"],
        },
        {
          id: "global-starter",
          name: "Starter sequence",
          category: "Global",
          slots: [
            "Hero / Pack Shot",
            "Ingredient Callout",
            "Lifestyle (Plated)",
            "Ingredient Hero",
            "Lifestyle (Plated)",
            "Prep / Microwave Steps",
            "Nutrition / Claims Panel",
          ],
        },
      ];
      this.persistLibrary();
    },
    persistLibrary() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.sequences));
      } catch (e) {
        return;
      }
    },
    loadActive() {
      try {
        const raw = localStorage.getItem(ACTIVE_KEY);
        if (!raw) return;
        const st = JSON.parse(raw);
        if (!st || typeof st !== "object") return;
        if (st.type === "auto" || st.type === "sequence" || st.type === "playbook") this.activeType = st.type;
        if (typeof st.id === "string") this.activeId = st.id;
      } catch (e) {
        return;
      }
    },
    persistActive() {
      try {
        localStorage.setItem(ACTIVE_KEY, JSON.stringify({ type: this.activeType, id: this.activeId }));
      } catch (e) {
        return;
      }
    },
    selectSource(src) {
      this.activeType = "auto";
      this.activeId = src.id;
      this.persistActive();
      this.$emit("change", { type: "auto", id: src.id });
      this.closeAll();
    },
    selectSequence(seq) {
      this.activeType = "sequence";
      this.activeId = seq.id;
      this.persistActive();
      this.$emit("change", { type: "sequence", id: seq.id, sequence: seq });
      this.closeAll();
    },
    selectPlaybook(pb) {
      this.activeType = "playbook";
      this.activeId = pb.id;
      this.persistActive();
      this.$emit("change", { type: "playbook", id: pb.id, playbook: pb });
      if (pb && pb.report_link && typeof window.showPlaybookInTab === "function") {
        try {
          window.showPlaybookInTab(pb.report_link, pb.title || "Playbook", Number(pb.id), pb.report_uuid || "", true);
        } catch (e) {
          // ignore
        }
      }
      this.closeAll();
    },
    openBuildModal() {
      this.closeAll();
      this.saveName = this.activeType === "sequence"
        ? (this.sequences.find(s => s.id === this.activeId)?.name || "")
        : "Custom sequence";
      // window.$(`#${this.buildModalId}`).modal("show");
      this.$bvModal.show("build-sequence-modal");
    },
    openSaveModal() {
      this.closeAll();
      this.saveName = this.activeType === "sequence"
        ? (this.sequences.find(s => s.id === this.activeId)?.name || "")
        : "Visual Benchmark — Frozen Family Meals";
      window.$(`#${this.saveModalId}`).modal("show");
    },
    openLibraryModal() {
      this.closeAll();
      window.$(`#${this.libraryModalId}`).modal("show");
    },
    openNewSequenceModal() {
      this.closeAll();
      this.newSeqName = "";
      this.newSeqScope = "Global";
      this.newSeqSlots = [];
      this.newSeqSlotText = "";
      window.$(`#${this.libraryModalId}`).modal("hide");
      window.$(`#${this.newModalId}`).modal("show");
    },
    backToLibraryFromNew() {
      window.$(`#${this.newModalId}`).modal("hide");
      window.$(`#${this.libraryModalId}`).modal("show");
    },
    backToLibraryFromEdit() {
      window.$(`#${this.editModalId}`).modal("hide");
      window.$(`#${this.libraryModalId}`).modal("show");
    },
    addNewSeqSlot() {
      const label = this.newSeqSlotText.trim();
      if (!label) return;

      this.newSeqSlots.push({
        id: this.nextId++,
        label,
      });

      this.newSeqSlotText = "";
    },
    addEditSlot() {
      const v = String(this.editSeqSlotText || "").trim();
      if (!v) return;
      this.editSeqSlots = this.editSeqSlots.concat([v]);
      this.editSeqSlotText = "";
    },
    moveEditSlot(idx, delta) {
      const slots = this.editSeqSlots.slice();
      const next = idx + delta;
      if (next < 0 || next >= slots.length) return;
      const tmp = slots[idx];
      slots[idx] = slots[next];
      slots[next] = tmp;
      this.editSeqSlots = slots;
    },
    removeEditSlot(idx) {
      if (idx < 0 || idx >= this.editSeqSlots.length) return;
      const slots = this.editSeqSlots.slice();
      slots.splice(idx, 1);
      this.editSeqSlots = slots;
    },
    openEditSequenceModal(seq) {
      this.closeAll();
      this.editingSequenceId = seq.id;
      this.editSeqName = String(seq.name || "");
      this.editSeqScope = String(seq.category || "Global");
      this.editSeqSlots = Array.isArray(seq.slots) ? seq.slots.map(s => String(s || "").trim()).filter(Boolean) : [];
      this.editSeqSlotText = "";
      window.$(`#${this.libraryModalId}`).modal("hide");
      // window.$(`#${this.editModalId}`).modal("show");
      this.selectedSequence = {
        ...seq,
        slots: Array.isArray(seq.slots)
        ? [...seq.slots]
        : String(seq.slots)
            .split(' · ')
            .map(s => s.trim())
            .filter(Boolean),
      };

      this.$nextTick(() => {
        this.$bvModal.show('build-sequence-modal');
      });
    },
    saveEditedSequence() {
      if (!this.canSaveEditSequence) return;
      if (!this.editingSequenceId) return;

      const name = String(this.editSeqName || "").trim();
      const scope = String(this.editSeqScope || "").trim() || "Global";
      const slots = Array.isArray(this.editSeqSlots) ? this.editSeqSlots.map(s => String(s || "").trim()).filter(Boolean) : [];
      if (!name || !slots.length) return;

      const idx = this.sequences.findIndex(s => s.id === this.editingSequenceId);
      if (idx === -1) return;

      const updated = {
        ...this.sequences[idx],
        name,
        category: scope,
        slots,
      };
      this.$set(this.sequences, idx, updated);
      this.persistLibrary();

      if (this.activeType === "sequence" && this.activeId === updated.id) {
        this.$emit("change", { type: "sequence", id: updated.id, sequence: updated });
      }

      this.backToLibraryFromEdit();
    },
    saveNewSequence() {
      const name = String(this.newSeqName || "").trim();
      const scope = String(this.newSeqScope || "").trim() || "Global";

      this.handleSave({
        name: name,
        scope: this.newSeqScope,
        slots: this.newSeqSlots.map(s => ({
          label: s.label,
          type: s.meta === 'Built-in' ? 'built-in' : 'custom'
        }))
      });

      this.persistLibrary();
      this.activeType = "sequence";
      this.persistActive();
      this.backToLibraryFromNew();
    },
    useStarterSet() {
      this.buildText = "Hero / Pack Shot\nIngredient Callout\nLifestyle (Plated)\nIngredient Hero\nLifestyle (Plated)\nPrep / Microwave Steps\nNutrition / Claims Panel";
      this.newSlot = "";
    },
    clearBuild() {
      this.buildText = "";
      this.newSlot = "";
    },
    addSlot() {
      const v = String(this.newSlot || "").trim();
      if (!v) return;
      const lines = this.buildSlots.concat([v]);
      this.buildText = lines.join("\n");
      this.newSlot = "";
    },
    applyBuiltSequence() {
      const slots = this.buildSlots;
      if (!slots.length) return;
      const tmp = {
        id: `custom-${Date.now()}`,
        name: "Custom sequence",
        category: "Global",
        slots,
        temporary: true,
      };
      this.editingSequenceId = null;
      this.$emit("applyCustom", tmp);
      this.activeType = "sequence";
      this.activeId = tmp.id;
      this.persistActive();
      window.$(`#${this.buildModalId}`).modal("hide");
    },
    moveSlot(idx, delta) {
      const slots = this.buildSlots.slice();
      const next = idx + delta;
      if (next < 0 || next >= slots.length) return;
      const tmp = slots[idx];
      slots[idx] = slots[next];
      slots[next] = tmp;
      this.buildText = slots.join("\n");
    },
    removeSlot(idx) {
      const slots = this.buildSlots.slice();
      if (idx < 0 || idx >= slots.length) return;
      slots.splice(idx, 1);
      this.buildText = slots.join("\n");
    },
    saveBuiltToLibrary() {
      if (!this.canSaveBuiltToLibrary) return;
      const name = String(this.saveName || "").trim();
      const slots = this.buildSlots;
      const created = {
        id: `seq-${Date.now()}`,
        name,
        category: "Global",
        slots,
      };
      this.sequences.push(created);
      this.persistLibrary();
      this.activeType = "sequence";
      this.activeId = created.id;
      this.persistActive();
      this.$emit("change", { type: "sequence", id: created.id, sequence: created });
      window.$(`#${this.buildModalId}`).modal("hide");
    },
    saveAndApplyBuiltSequence() {
      if (!this.canSaveBuiltToLibrary) return;
      this.saveBuiltToLibrary();
      window.$(`#${this.buildModalId}`).modal("hide");
    },
    saveToLibrary() {
      const name = String(this.saveName || "").trim();
      const slots = this.buildSlots;
      if (!name || !slots.length) return;

      let selectedId = null;
      if (this.editingSequenceId) {
        const idx = this.sequences.findIndex(s => s.id === this.editingSequenceId);
        if (idx !== -1) {
          this.$set(this.sequences, idx, {
            ...this.sequences[idx],
            name,
            slots,
          });
          selectedId = this.editingSequenceId;
        }
        this.editingSequenceId = null;
      } else {
        const created = {
          id: `seq-${Date.now()}`,
          name,
          category: "Global",
          slots,
        };
        this.sequences.push(created);
        selectedId = created.id;
      }

      this.persistLibrary();
      if (selectedId) {
        const seq = this.sequences.find(s => s.id === selectedId);
        if (seq) {
          this.activeType = "sequence";
          this.activeId = selectedId;
          this.persistActive();
          this.$emit("change", { type: "sequence", id: selectedId, sequence: seq });
        }
      }
      window.$(`#${this.saveModalId}`).modal("hide");
    },
    newSequenceFromScratch() {
      this.editingSequenceId = null;
      this.buildTab = "bulk";
      this.buildText = "";
      window.$(`#${this.libraryModalId}`).modal("hide");
      this.openBuildModal();
    },
    editSequence(seq) {
      this.openEditSequenceModal(seq);
    },
    deleteSequence(seq) {
      const idx = this.sequences.findIndex(s => s.id === seq.id);
      if (idx === -1) return;
      this.sequences.splice(idx, 1);
      this.persistLibrary();
      if (this.activeType === "sequence" && this.activeId === seq.id) {
        this.activeType = "auto";
        this.activeId = "visual-benchmark";
        this.persistActive();
      }
    },
    async handleSave(payload) {
      await axios.post('/sequences', payload);
      this.fetchSequences();
    },
    async handleUpdate(payload) {
      await axios.put(`/sequences/${payload.sequence}`, payload);
      this.fetchSequences();
    },
    async handleDelete(sequenceId) {
      const seq = this.sequences.find((sequence) => sequence.id === sequenceId);
      if (!seq) return;

      const index = this.sequences.findIndex((sequence) => sequence.id === sequenceId);
      this.deleteSequence(seq);

      try {
        await axios.delete(`/sequences/${sequenceId}`);
      } catch (error) {
        this.sequences.splice(index, 0, seq);
        this.persistLibrary();
        console.error('Failed to delete sequence', error);
      }
    },
    async fetchSequences() {
      const result = await axios.get('/sequences');

      if (result.status === 200) {
        this.sequences = result.data;
      }
    },
  },
};
</script>

<style  scoped lang="scss">
.isd-sprite {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
}
.isd {
  --isd-bg: #ffffff;
  --isd-border: #e2e8f0;
  --isd-muted: #64748b;
  --isd-text: #0f172a;
  --isd-accent: #f1f5f9;
  --isd-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -4px rgba(0, 0, 0, 0.08);
  --isd-primary: #1cbd9d;
  --isd-danger: #dc2626;

  &, * , *::before, *::after {
    box-sizing: border-box;
  }

  :deep(.isd-svg) {
    display: block;
    width: 1rem;
    height: 1rem;
    flex: 0 0 auto;
  }
  :deep(.isd-svg--12) { width: .75rem; height: .75rem; }
  :deep(.isd-svg--14) { width: .875rem; height: .875rem; }
  :deep(.isd-svg--16) { width: 1rem; height: 1rem; }
  :deep(.isd-svg--20) { width: 1.25rem; height: 1.25rem; }
  :deep(.isd-svg--check) { color: #059669; }
}

.isd-modal__close :deep(.isd-svg) { width: 1rem !important; height: 1rem !important; }

.isd__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: .375rem;
  height: 32px;
  padding: 0 .75rem;
  max-width: 260px;
  border: 1px solid var(--isd-border);
  border-radius: .375rem;
  background: var(--isd-bg);
  color: var(--isd-text);
  font-weight: 600;
  font-size: 12px;
  line-height: 1;
  box-shadow: none;
}
.isd__btn:hover {
  background: var(--isd-accent);
}
.isd__btn:focus { outline: none; box-shadow: none; }
.isd__btn:focus-visible {
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.12);
}
.isd__btn--open {
  background: var(--isd-accent);
}
.isd__btnIcon,
.isd__btnChevron {
  opacity: .85;
  display: inline-flex;
  align-items: center;
}
.isd__btnChevron {
  opacity: .6;
}
.isd__btnLabel {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.isd__menu {
  width: 18rem;
  padding: .25rem;
  border: 1px solid var(--isd-border);
  border-radius: .375rem;
  box-shadow: var(--isd-shadow);
  // Override global analytics dropdown rule (max-height + scroll) so nested popouts
  // are not clipped and the menu doesn't get an unnecessary scrollbar.
  max-height: none !important;
  overflow: visible !important;
}

.isd__seqScroll {
  max-height: 240px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.isd__sectionTitle {
  padding: .375rem .5rem;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: .375rem;
}
.isd__sectionIcon { opacity: .6; color: var(--isd-muted); }
.isd__sectionMeta {
  margin-left: auto;
  font-size: 10px;
  font-weight: 400;
  color: var(--isd-muted);
  font-style: italic;
}

.isd__searchWrap {
  padding: 0 .5rem .25rem;
  position: relative;
}
.isd__searchIcon {
  position: absolute;
  left: 1rem;
  // Center relative to the 28px input (not the padded wrapper)
  top: 14px;
  transform: translateY(-50%);
  opacity: .5;
  color: var(--isd-muted);
  pointer-events: none;
}
.isd__searchInput {
  height: 28px !important;
  padding: .25rem .5rem !important;
  padding-left: 1.7rem !important;
  font-size: 12px !important;
  border-radius: 6px !important;
}

.isd__playbookScroll {
  max-height: 120px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.isd__submenu {
  position: relative;
}
.isd__submenuTrigger {
  display: flex;
  align-items: center;
}
.isd__submenuChevron {
  margin-left: auto;
  opacity: .6;
  display: inline-flex;
  align-items: center;
}
.isd__submenuContent {
  position: absolute;
  top: 0;
  // Menu is right-aligned; open popout to the left so it stays on-screen.
  left: auto;
  right: calc(100% - 6px);
  width: 18rem;
  padding: .25rem;
  border: 1px solid var(--isd-border);
  border-radius: .375rem;
  box-shadow: var(--isd-shadow);
  background: var(--isd-bg);
  z-index: 1060;
}

.isd__item {
  font-size: 12px;
  padding: .375rem .5rem;
  border-radius: .2rem;
  display: flex;
  align-items: center;
  gap: .5rem;
  white-space: normal;
}
.isd__item:focus,
.isd__item:hover {
  background: var(--isd-accent);
  color: var(--isd-text);
}
.isd__itemIcon {
  width: 1rem;
  height: 1rem;
  opacity: .6;
  color: var(--isd-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: .25rem;
}
.isd__itemBody {
  min-width: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}
.isd__itemTitle {
  display: block;
}
.isd__itemSub {
  display: block;
  font-size: 10px;
  color: #6b7280;
  margin-top: 2px;
}
.isd__check {
  flex: 0 0 auto;
}
.isd__actionText {
  flex: 1 1 auto;
}

.isd-modal {
  .modal-dialog {
    margin: 1.75rem auto !important;
    max-width: 100%;
    padding: 0 12px !important;
  }

  .modal-content {
    border: 0 !important;
    background: transparent !important;
  }
}

.isd-modal .modal-content.isd-modal__content {
  background: var(--isd-bg) !important;
  border: 1px solid var(--isd-border) !important;
}

.isd-modal .modal-dialog {
  max-width: 100%;
}
.isd-modal.modal {
  text-align: left;
}
.isd-modal.modal .modal-dialog-centered {
  min-height: calc(100% - 3.5rem);
}
.isd-modal__dialog--xl { max-width: 576px !important; }
.isd-modal__dialog--md { max-width: 448px !important; }
.isd-modal__dialog--lg { max-width: 768px !important; }

.isd-modal__content {
  border: 1px solid var(--isd-border) !important;
  border-radius: .5rem !important;
  background: var(--isd-bg) !important;
  box-shadow: var(--isd-shadow) !important;
  padding: 24px !important;
  display: grid;
  gap: 16px !important;
  position: relative;
}

.isd-modal__header { padding: 0; }
.isd-modal__titleRow {
  display: flex;
  align-items: center;
  gap: .5rem;
}
.isd-modal__titleIcon {
  color: var(--isd-primary) !important;
  display: inline-flex;
  align-items: center;
}
.isd-modal__title {
  font-weight: 600;
  font-size: 1.125rem;
  color: var(--isd-text);
  line-height: 1;
  letter-spacing: -.025em;
}
.isd-modal__subtitle {
  margin-top: .25rem;
  font-size: 14px;
  color: #6b7280;
}
.isd-modal__body { padding: 0; }
.isd-modal__footer {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px !important;
  padding-top: 8px !important;
}
.isd-modal__footerRight {
  display: flex;
  align-items: center;
  gap: 8px;
}
.isd-modal__footer--right {
  justify-content: flex-end;
  gap: .5rem;
}
.isd-modal__close {
  position: absolute;
  top: 16px;
  right: 16px;
  border: 0;
  background: transparent;
  padding: 0 !important;
  width: 32px !important;
  height: 32px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px !important;
  opacity: .7;
}
.isd-modal__close:hover {
  opacity: 1;
  background: var(--isd-accent);
}
.isd-modal__close:focus {
  outline: none !important;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.12) !important;
}

.isd-btn {
  border-radius: .375rem;
  font-weight: 500;
  font-size: 14px;
  padding: 8px 12px !important;
  border: 1px solid transparent !important;
  line-height: 1.2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: .25rem;
}
.isd-modal__tools .isd-btn {
  height: 28px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
}
.isd-modal__tools .isd-btn--danger .isd-btn__icon .isd-svg,
.isd-modal__tools .isd-btn--danger .isd-btn__icon svg {
  width: .75rem !important;
  height: .75rem !important;
}
.isd-modal__tools .isd-btn .isd-svg,
.isd-modal__tools .isd-btn svg {
  width: 1rem;
  height: 1rem;
}
.isd-modal__footer .isd-btn {
  height: 36px;
  padding: 0 12px !important;
  border-radius: 6px !important;
}
.isd-btn--primary {
  background: var(--isd-primary) !important;
  border-color: var(--isd-primary) !important;
  color: #fff !important;
}
.isd-btn--primary:hover {
  filter: brightness(.95);
  color: #fff;
}
.isd-btn--outline {
  background: var(--isd-bg) !important;
  border-color: var(--isd-border) !important;
  color: var(--isd-text) !important;
}
.isd-btn--outline:hover {
  background: var(--isd-accent) !important;
}
.isd-btn:disabled,
.isd-btn[disabled],
.isd-iconBtn:disabled,
.isd-iconBtn[disabled] {
  opacity: .5;
  pointer-events: none;
}
.isd-btn--ghost {
  background: transparent !important;
  border-color: transparent !important;
  color: var(--isd-text) !important;
}
.isd-btn--ghost:hover {
  background: var(--isd-accent) !important;
}
.isd-btn--danger {
  color: var(--isd-danger) !important;
}
.isd-btn--danger:hover {
  background: rgba(220, 38, 38, 0.08) !important;
  color: var(--isd-danger) !important;
}
.isd-btn--h8 {
  height: 32px !important;
  padding: 0 12px !important;
  border-radius: 6px !important;
  font-size: 14px !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.isd-btn__icon { display: inline-flex; align-items: center; justify-content: center; vertical-align: middle; }
.isd-btn__icon .isd-svg,
.isd-btn__icon svg {
  display: block;
}

.isd-tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .75rem;
}
.isd-tabs__group {
  background: #f1f5f9;
  border-radius: .5rem !important;
  padding: .25rem !important;
  height: 32px !important;
  overflow: hidden;
}
.isd-tabs__btn {
  font-size: 12px;
  border-radius: 4px;
  padding: 6px 12px;
  border: 0;
  background: transparent;
  color: #64748b;
  height: 24px;
  display: inline-flex;
  align-items: center;
  line-height: 1;
}
.btn-group .isd-tabs__btn{
  border-radius: 4px !important;
}
.isd-tabs__btn.active {
  background: #fff;
  color: var(--isd-text);
  box-shadow: 0 1px 2px rgba(0,0,0,.05);
}
.isd-modal__tools { display: flex; align-items: center; gap: .5rem; }
.isd-modal__tools .isd-btn {
  line-height: 1;
}

.isd-label {
  display: block;
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
  margin-bottom: .35rem;
}
.isd-label--save {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: var(--isd-text) !important;
  margin-bottom: 8px !important;
}

.isd-caption {
  font-size: 11px !important;
  color: #6b7280 !important;
  margin-top: .5rem !important;
}

.isd-input {
  display: block;
  width: 100%;
  border: 1px solid var(--isd-border) !important;
  background: var(--isd-bg) !important;
  padding: 8px 12px !important;
  font-size: 14px !important;
  line-height: 1.2;
}
.isd-input--rounded {
  border-radius: 6px !important;
}
.isd-input:focus {
  outline: none !important;
  border-color: rgba(15, 23, 42, 0.35) !important;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.12) !important;
}

.isd-save__field {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.isd-textarea {
  min-height: 260px;
  border-radius: 6px;
  border-color: var(--isd-border) !important;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 14px;
  line-height: 1.6;
}
.isd-textarea:focus {
  border-color: rgba(28, 189, 157, 0.6) !important;
  box-shadow: 0 0 0 2px rgba(28, 189, 157, 0.15) !important;
}
.isd-help {
  margin-top: .4rem;
  font-size: 12px;
  color: #6b7280;
}
.isd-input--h10 { height: 40px; }
.isd-input--h9 { height: 36px !important; }

.isd-modal--save .isd-input--h10 {
  height: 40px !important;
  min-height: 40px !important;
  border-radius: 6px !important;
  font-size: .875rem !important;
  line-height: 1.25rem !important;
  padding: .5rem .75rem !important;
}
.isd-modal--save .isd-modal__footer--right {
  gap: .5rem !important;
  padding-top: 8px !important;
}

.isd-list {
  border: 1px solid var(--isd-border);
  border-radius: .5rem;
  overflow: hidden;
}
.isd-list__row {
  display: flex;
  align-items: center;
  gap: .5rem;
  padding: .5rem;
  padding-left: .75rem;
  border-bottom: 1px solid rgba(226,232,240,.9);
  background: #fff;
}
.isd-list__row:hover {
  background: rgba(241,245,249,.6);
}
.isd-list__row:last-child { border-bottom: 0; }
.isd-list__num {
  width: 1.5rem;
  flex: 0 0 auto;
  color: #6b7280;
  font-weight: 500;
  font-size: .75rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-variant-numeric: tabular-nums;
}
.isd-list__text {
  flex: 1 1 auto;
  min-width: 0;
  font-size: .875rem;
  color: var(--isd-text);
}
.isd-listLabel {
  font-size: 12px;
  font-weight: 600;
  color: var(--isd-text);
  margin-top: 4px;
  margin-bottom: 4px;
}
.isd-list__actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: .125rem;
  opacity: 0;
  transition: opacity .15s ease;
}
.isd-list__row--hover:hover .isd-list__actions {
  opacity: 1;
}
.isd-list__actions .isd-iconBtn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
}
.isd-list__actions .isd-iconBtn :deep(.isd-svg) {
  width: .875rem !important;
  height: .875rem !important;
}
.isd-list__add {
  display: flex;
  align-items: center;
  gap: .5rem;
  padding: .75rem;
  background: #fff;
  border-top: 1px solid rgba(226,232,240,.9);
}
.isd-list__add .isd-input {
  height: 36px !important;
}
.isd-btn--h9 {
  height: 36px !important;
  padding: 0 12px !important;
  border-radius: 6px !important;
  gap: .25rem !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  white-space: nowrap !important;
}
.isd-btn--h9 .isd-btn__icon {
  margin-right: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.isd-btn--h9 .isd-btn__icon :deep(.isd-svg) {
  width: .875rem !important;
  height: .875rem !important;
}
.isd-search { position: relative; flex: 1 1 auto; max-width: 320px; }
.isd-search__icon { position: absolute; left: .65rem; top: 50%; transform: translateY(-50%); opacity: .6; }
.isd-search__input {
  box-sizing: border-box !important;
  display: block !important;
  width: 100% !important;
  height: 36px !important;
  min-height: 36px !important;
  padding: .5rem .75rem !important;
  padding-left: 2rem !important;
  line-height: 1.25rem !important;
  font-size: .875rem !important;
  border-radius: 6px !important;
  border: 1px solid var(--isd-border) !important;
  background: var(--isd-bg) !important;
}

.isd-buildName {
  padding-top: 8px;
  border-top: 1px solid rgba(226,232,240,.9);
  margin-top: 4px;
}

:deep(.text-truncate) {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  min-width: 0 !important;
}
:deep(.truncate) {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  min-width: 0 !important;
}

.isd-libraryTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .75rem;
  margin-bottom: .75rem;
}

.isd-new__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: .75rem;
}
.isd-label--new {
  font-size: .75rem !important;
  font-weight: 500 !important;
  color: var(--isd-text) !important;
  margin-bottom: .35rem !important;
}
.isd-new__slots {
  margin-top: .5rem;
}
.isd-new__slotBox {
  border: 1px solid var(--isd-border) !important;
  border-radius: .5rem !important;
  max-height: 40vh;
  overflow-y: auto;
}
.isd-new__empty {
  padding: 2rem 1rem !important;
  text-align: center;
  font-size: .875rem;
  color: #6b7280;
}
.isd-new__slotList {
  width: 100%;
}
.isd-new__slotRow {
  display: flex;
  align-items: center;
  gap: .5rem;
  padding: .5rem .75rem;
  border-bottom: 1px solid rgba(226,232,240,.9);
}
.isd-new__slotRow:last-child { border-bottom: 0; }
.isd-new__slotNum {
  width: 2rem;
  text-align: center;
  font-weight: 600;
  color: #94a3b8;
  font-variant-numeric: tabular-nums;
  flex: 0 0 auto;
}
.isd-new__slotText {
  min-width: 0;
  flex: 1 1 auto;
}
.isd-new__slotAdd {
  display: flex;
  align-items: center;
  gap: .5rem;
  padding: .5rem !important;
  border-top: 1px solid rgba(226,232,240,.9) !important;
  background: rgba(241,245,249,.4) !important;
}
.isd-new__slotInput {
  height: 36px !important;
}
.isd-new__addBtn {
  height: 36px !important;
  padding: 0 12px !important;
  gap: .25rem;
  flex: 0 0 auto;
  white-space: nowrap;
}
.isd-libraryList {
  border: 1px solid var(--isd-border);
  border-radius: .5rem;
  max-height: 50vh;
  overflow-y: auto;
  width: 100%;
}
.isd-row {
  display: flex;
  align-items: flex-start;
  gap: .75rem;
  padding: .75rem;
  border-bottom: 1px solid rgba(226,232,240,.9);
  width: 100%;
}
.isd-row:last-child { border-bottom: 0; }
.isd-row:hover { background: rgba(241,245,249,.6); }
.isd-row__main { flex: 1 1 auto; min-width: 0; }
.isd-row__titleRow {
  display: flex;
  align-items: center;
  gap: .5rem;
  flex-wrap: wrap;
  min-width: 0;
}
.isd-row__title {
  font-weight: 500;
  font-size: 14px;
  color: var(--isd-text);
  min-width: 0;
  flex: 0 1 auto;
  max-width: calc(100% - 7.5rem);
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
}
.isd-row__sub {
  margin-top: .25rem;
  font-size: 12px;
  color: #6b7280;
  max-width: 520px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
}
.isd-pill {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--isd-border);
  border-radius: 999px;
  padding: .1rem .5rem;
  font-size: 10px;
  color: var(--isd-text);
  flex: 0 0 auto;
}
.isd-row__actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: .25rem;
  opacity: 0;
  transition: opacity .15s ease;
}
.isd-row:hover .isd-row__actions {
  opacity: 1;
}
.isd-iconBtn {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 6px;
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.isd-iconBtn:hover {
  background: var(--isd-accent);
}
.isd-iconBtn :deep(.isd-svg) {
  width: .875rem !important;
  height: .875rem !important;
}
.isd-iconBtn--danger {
  color: var(--isd-danger);
}
.isd-iconBtn--danger:hover {
  background: rgba(220, 38, 38, 0.08);
}
.seq-slots {
  font-size: 12.5px;
  color: #8a9099;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 480px;
}
</style>

